import { render, staticRenderFns } from "./ManufacturersPage.vue?vue&type=template&id=288d5a7c"
import script from "./ManufacturersPage.vue?vue&type=script&lang=js"
export * from "./ManufacturersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports